<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="姓名" prop="nickname">
                <a-input v-model="queryParam.nickname" placeholder="请输入" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="手机号" prop="mobile">
                <a-input v-model="queryParam.mobile" placeholder="请输入" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="身份证" prop="idCard">
                <a-input v-model="queryParam.idCard" placeholder="请输入" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
<!--      <create-form-->
<!--        ref="createForm"-->
<!--        @ok="getList"-->
<!--      />-->
<!--      <set-top-form-->
<!--        ref="setTopForm"-->
<!--      />-->
<!--      <user-form-->
<!--        ref="userForm"-->
<!--      />-->
<!--      <brokerage-record-form-->
<!--        ref="brokerageRecordForm"-->
<!--      />-->

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 1900}"
      >
         <span slot="status" slot-scope="text, record">
          <div>
            <a-switch @click="updateUserStatus(record)" v-model="record.status == 1">
              <a-icon type="check" slot="checkedChildren"/>
              <a-icon type="close" slot="unCheckedChildren"/>
            </a-switch>
          </div>
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="wxCodeUrl" slot-scope="text, record">
          <img
            v-viewer
            style="width: 20px;height: 20px;margin-right: 5px;margin-bottom: 5px"
            :src="record.wxCodeUrl"
          />
        </span>
        <span slot="shareQrUrl" slot-scope="text, record">
          <img
            v-viewer
            style="width: 20px;height: 20px;margin-right: 5px;margin-bottom: 5px"
            :src="record.shareQrUrl"
          />
        </span>
        <span slot="address" slot-scope="text, record">
          <div>{{ record.province }}{{ record.city }}{{ record.county }}{{ record.address }}</div>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical"/>
          <a @click="$refs.cardForm.handleUpdate(record, undefined)">
            <a-icon type="edit"/>查看
          </a>
          <a-divider type="vertical"/>
          <a @click="$refs.clientForm.handleQuery(record)">
            <a-icon type="user"/>推荐官列表
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
      <!-- 查看/修改 -->
      <card-form
        ref="cardForm"
        @ok="getList"
      />
      <client-form
        ref="clientForm"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageReferrals, updateUserStatus, delReferrals, updateReferrals } from '@/api/user/topReferrals'
import { tableMixin } from '@/store/table-mixin'
import CardForm from './modules/CardForm'
import ClientForm from './modules/ClientForm'
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
import Vue from 'vue'
Vue.use(VueViewer)
// 设置初始值
VueViewer.setDefaults({
  Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})
export default {
  name: 'topReferrals',
  components: {
    CardForm,
    ClientForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      operateTitle: null,
      operateOpen: null,
      operateType: null,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      id: null,
      thisData: {},
      status: 1,
      total: 0,
      // 查询参数
      queryParam: {
        nickname: null,
        mobile: null,
        idCard: null,
        topUserNickname: null,
        userId: null,
        idCardFront: null,
        idCardReverse: null,
        fileUrl: null,
        status: null,
        cateName: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          ellipsis: true,
          width: 180,
          align: 'center'
        },
        {
          title: '姓名',
          dataIndex: 'nickname',
          ellipsis: true,
          width: 120,
          align: 'center'
        },
        {
          title: '手机号',
          dataIndex: 'mobile',
          ellipsis: true,
          width: 120,
          align: 'center'
        },
        {
          title: '邮箱',
          dataIndex: 'email',
          width: 180,
          align: 'center'
        },
        {
          title: '身份证号',
          dataIndex: 'idCard',
          width: 180,
          align: 'center'
        },
        {
          title: '性别',
          dataIndex: 'sex',
          ellipsis: true,
          width: 80,
          align: 'center',
          customRender: function (sex) {
            if (sex === 0) {
              return '保密'
            } else if (sex === 1) {
              return '男'
            } else if (sex === 2) {
              return '女'
            }
          }
        },
        {
          title: '微信号',
          dataIndex: 'wxCode',
          ellipsis: true,
          width: 120,
          align: 'center'
        },
        {
          title: '微信二维码',
          dataIndex: 'wxCodeUrl',
          ellipsis: true,
          scopedSlots: { customRender: 'wxCodeUrl' },
          width: 120,
          align: 'center'
        },
        {
          title: '分享小程序码',
          dataIndex: 'shareQrUrl',
          ellipsis: true,
          scopedSlots: { customRender: 'shareQrUrl' },
          width: 120,
          align: 'center'
        },
        {
          title: '定位所在地',
          dataIndex: 'address',
          width: 350,
          scopedSlots: { customRender: 'address' },
          align: 'center'
        },
        {
          title: '操作状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          width: 120,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    checkBankStatus(record) {
      debugger
      this.thisData = record
      this.id = record.bankId
      const status = record.bankStatus
      if (status == 1) {
        this.operateTitle = '审核推荐官银行卡绑定'
        this.operateType = 2
        this.status = 2
      }
      if (status == 4) {
        this.operateTitle = '审核推荐官银行卡解绑'
        this.operateType = 3
        this.status = 5
      }
      this.operateOpen = true
    },
    operateOk() {
      const that = this
      const param = {
        id: that.id,
        status: that.status
      }
      if (that.operateType == 1) {
        updateReferrals(param).then(() => {
          that.getList()
          that.$message.success(
            '操作成功',
            3
          )
          this.operateClose()
        })
      }
      if (that.operateType == 2 || that.operateType == 3) {
        updateBank(param).then(() => {
          that.getList()
          that.$message.success(
            '操作成功',
            3
          )
          this.operateClose()
        })
      }
    },
    operateClose() {
      this.operateOpen = false
      this.operateTitle = null
      this.operateType = null
      this.id = null
      this.status = 1
    },
    checkStatus(id) {
      this.id = id
      this.operateTitle = '审核推荐官信息'
      this.operateOpen = true
      this.operateType = 1
    },
    async copyToClipboard(text) {
      try {
        await navigator.clipboard.writeText(text)
        this.$message.success('内容已复制到剪贴板')
      } catch (err) {
        this.$message.success('复制到剪贴板失败')
      }
    },
    updateUserStatus(record) {
      // 更改状态
      let param = {
        ids: [record.id],
        status: record.status
      }
      updateUserStatus(param).then(response => {
        this.$message.success(
          '修改成功',
          3
        )
        this.$emit('ok')
      }).finally(() => {
        this.getList()
      })
    },
    /** 查询推荐官申请列表 */
    getList () {
      this.loading = true
     pageReferrals(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        userId: undefined,
        idCardFront: undefined,
        idCardReverse: undefined,
        fileUrl: undefined,
        status: undefined,
        cateName: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          const data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delReferrals(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('user/user-referrals/export', {
            ...that.queryParam
          }, `推荐官申请_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
